import React, { Component } from 'react';
import { SpaLayout } from './SpaLayout';
import { connect } from 'react-redux';
import { breadCrumbItems } from '../../utils/spaConstants';

class SpaServices extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        // eslint-disable-next-line no-undef
        document.title = "Error";
    }

    render() {
        let { services = {}, reservations = {} } = this.props;
        let { authDetails = {} } = services;
        let { cart = [] } = reservations;
        let { appTrigger = 'CP' } = authDetails;
        return (<SpaLayout cart={cart} items={breadCrumbItems.services} appTrigger={appTrigger}>
            <main id="container">
                <div className="spa-content error-page text-center white-bg-tint  spa-font-family cp-border-radius">
                    <div className='spa-error-container'>
                        <h1 style={{ fontSize: '22px' }}>We apologize for the inconvenience.</h1>
                        <p className='font-size-p4 gotham-book red'>Something has gone wrong and we were not able to continue to the next step. {/* For help please call: 1-888-216-0198 */}</p>
                    </div>
                </div>
            </main>
        </SpaLayout>)
    }
}

const mapStateToProps = (state) => {
    return {
        services: state.services,
        reservations: state.reservations,
    };
};

export default connect(mapStateToProps, null)(SpaServices);
